import * as React from 'react'

import { Typography } from '@mui/material'

import { MUIRouterLink } from '@edge/spark/ui-mui'

interface Props {
    href?: string
    children: React.ReactNode
}

const LinkCell: React.FC<Props> = ({ href, children }: Props) =>
    href ? (
        <MUIRouterLink href={href}>
            <Typography variant="inherit" color="primary">
                {children}
            </Typography>
        </MUIRouterLink>
    ) : (
        <Typography variant="inherit" color="primary">
            {children}
        </Typography>
    )

export default LinkCell
